module.exports = __webpack_public_path__ + "img/close.f1ecb6d6.svg";